<template>
  <FlightsReplay :axiosRequest="getCovidReplayFlights" />
</template>

<script>
import axios from 'axios'
import FlightsReplay from '@/components/flights-replay/FlightsReplay'

export default {
  components: { FlightsReplay },
  methods: {
    getCovidReplayFlights () {
      return axios.get('https://gist.githubusercontent.com/MaximeWillinger/b49e3c7eb4fa859fe5467b80058e4b8f/raw/af3eb1fcac7642fbef4b08835de7ecc5aa73a846/sample.geojson')
    }
  },
}
</script>

